import ContentWrap from './page-elements/ContentWrap'
import CtxButton from './base/CtxButton'
import CtxPagination from './base/CtxPagination'

export default {
  install: app => {
    app.component('ContentWrap', ContentWrap)
    app.component('CtxButton', CtxButton)
    app.component('CtxPagination', CtxPagination)
  }
}
